import CreateOperatorTemplateButton from './createProviderTemplate';

export default CreateOperatorTemplateButton;
